module.exports = __webpack_public_path__ + "static/media/5DPO11.2c29590d.jpg";